import InputBirthday from '@/components/common/inputs/InputBirthday'
import InputCheckbox from '@/components/common/inputs/InputCheckbox'
import InputCheckboxLegacy from '@/components/common/inputs/InputCheckboxLegacy'
import InputText from '@/components/common/inputs/InputText'
import InputTextArea from '@/components/common/inputs/InputTextArea'

export { InputBirthday, InputCheckbox, InputCheckboxLegacy, InputText, InputTextArea }
